import e from "@/lang/fr/error";

export default {
  contingent_hotelgamme: {
    show: {
      page_title: 'Type de chambre - détail'
    },
    list: {
      page_title: 'Liste des types'
    },
    edit: {
      page_title: 'Type de chambre - édition'
    },
    create: {
      page_title: 'Type de chambre - création'
    },
    form: {
      10: e.error[10]
    }
  },
  hotel_hotelgamme: {
    show: {
      page_title: 'Type de chambre - détail'
    },
    list: {
      page_title: 'Liste des types'
    },
    edit: {
      page_title: 'Type de chambre - édition'
    },
    create: {
      page_title: 'Type de chambre - création'
    },
    form: {
      10: e.error[10]
    }
  }
}
